exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding[data-v-2a3ff520] {\n  padding-left: 10%;\n}\n.buttonUnselected[data-v-2a3ff520] {\n  width: 100px;\n  background-color: white;\n  border: 1px solid var(--theme-primary);\n  border-radius: 5px;\n  color: var(--theme-primary);\n  min-width: 6em;\n  z-index: 0;\n}\ninput[type=radio]:checked + label[data-v-2a3ff520] {\n  background-color: var(--theme-primary);\n  border-color: var(--theme-primary);\n  color: white;\n  border-radius: 5px;\n  border-width: 1px;\n  z-index: 1;\n  font-family: 'Cera Round Pro Regular';\n}\n@media (max-width: 400px) {\n.buttonUnselected[data-v-2a3ff520] {\n    font-size: 0.6em;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a3ff520","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/multiplePhonePlan/PlanSelectToggle.vue
// module id = 801
// module chunks = 0